var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSwapStatusBarFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 295.387,
    height: 12,
    rx: 6,
    fill: "#D05353",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.741,
    cy: 7,
    r: 7,
    fill: "#D05353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.023 4.282a.96.96 0 000 1.359L286.382 7l-1.359 1.36a.96.96 0 101.359 1.358l1.359-1.359 1.359 1.36a.962.962 0 001.36-1.36L289.1 7l1.36-1.36a.962.962 0 00-1.36-1.358l-1.359 1.359-1.359-1.36a.96.96 0 00-1.359 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk2IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMjk2IDE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB5PSIxIiB3aWR0aD0iMjk1LjM4NyIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiNEMDUzNTMiIGZpbGwtb3BhY2l0eT0iMC4xIi8+CjxjaXJjbGUgY3g9IjI4Ny43NDEiIGN5PSI3IiByPSI3IiBmaWxsPSIjRDA1MzUzIi8+CjxwYXRoIGQ9Ik0yODUuMDIzIDQuMjgxNTJDMjg0LjY0NyA0LjY1Njg2IDI4NC42NDcgNS4yNjU0IDI4NS4wMjMgNS42NDA3NkwyODYuMzgyIDdMMjg1LjAyMyA4LjM1OTI0QzI4NC42NDcgOC43MzQ1OSAyODQuNjQ3IDkuMzQzMTIgMjg1LjAyMyA5LjcxODQ4QzI4NS4zOTggMTAuMDkzOCAyODYuMDA3IDEwLjA5MzggMjg2LjM4MiA5LjcxODQ4TDI4Ny43NDEgOC4zNTkyNEwyODkuMSA5LjcxODQ4QzI4OS40NzYgMTAuMDkzOCAyOTAuMDg0IDEwLjA5MzggMjkwLjQ2IDkuNzE4NDhDMjkwLjgzNSA5LjM0MzEzIDI5MC44MzUgOC43MzQ2IDI5MC40NiA4LjM1OTI0TDI4OS4xIDdMMjkwLjQ2IDUuNjQwNzZDMjkwLjgzNSA1LjI2NTQxIDI5MC44MzUgNC42NTY4OCAyOTAuNDYgNC4yODE1MkMyOTAuMDg0IDMuOTA2MTYgMjg5LjQ3NiAzLjkwNjE3IDI4OS4xIDQuMjgxNTJMMjg3Ljc0MSA1LjY0MDc2TDI4Ni4zODIgNC4yODE1MkMyODYuMDA3IDMuOTA2MTYgMjg1LjM5OCAzLjkwNjE3IDI4NS4wMjMgNC4yODE1MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgCrossSwapStatusBarFailed as ReactComponent };